import { UserType } from "../constants";

const initial =  []
  //const initial = []
export default (state = initial, event) => {
  switch (event.type) {
    case "UPDATE_ROW":
       
      return event.data          
      
    default:
      return state;
  }
};
